module.exports = __webpack_public_path__ + "img/GT.99bc9280.png";